import { HeartHandshake, Users, Megaphone, Globe } from "lucide-react";
import { Reveal, Rise } from "./Reveal";
import GlowButton from "./GlowButton";
import content from "../content";
import { SectionBg } from "./SectionBg";

const ICONS = {
  volunteer: HeartHandshake,
  local: Users,
  evangelism: Megaphone,
  global: Globe,
};

export default function MissionsMinistrySection() {
  const { missionsMinistry } = content;

  return (
    <section id="misiones" className="relative w-full bg-ink py-28 md:py-36 overflow-hidden" data-testid="missions-ministry-section">
      <SectionBg image="/images/missions-2.webp" tint="ink" />
      {missionsMinistry.bgImage && (
        <>
          <img
            src={missionsMinistry.bgImage}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 w-full h-full object-cover opacity-30"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-ink via-ink/60 to-ink" />
        </>
      )}
      <div className="relative w-full max-w-7xl mx-auto px-6">
        <Reveal className="max-w-3xl mb-14">
          <Rise>
            <p className="eyebrow mb-5">{missionsMinistry.eyebrow}</p>
          </Rise>
          <Rise>
            <h2 className="display text-white text-[clamp(2.25rem,6vw,4.75rem)]">
              {missionsMinistry.subtitle}
            </h2>
          </Rise>
        </Reveal>

        <Reveal className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" amount={0.1}>
          {missionsMinistry.cards.map((c, i) => {
            const Icon = ICONS[c.icon] || Globe;
            return (
              <Rise key={c.label}>
                <article
                  className="glass card-sweep group relative overflow-hidden p-8 h-full flex flex-col gap-6"
                  data-testid={`ministry-card-${i}`}
                >
                  <div className="w-14 h-14 rounded-2xl bg-electric/15 border border-electric/30 flex items-center justify-center text-electric group-hover:bg-electric group-hover:text-white group-hover:shadow-[0_0_24px_rgba(33,112,232,0.6)] transition-colors duration-400">
                    <Icon size={26} strokeWidth={1.8} />
                  </div>
                  <h3 className="display text-white text-2xl md:text-[1.6rem] leading-tight">
                    {c.label}
                  </h3>
                </article>
              </Rise>
            );
          })}
        </Reveal>

        <Reveal className="mt-16 text-center max-w-2xl mx-auto">
          <Rise>
            <p className="font-poppins text-ceramic/85 text-lg md:text-2xl leading-relaxed mb-9">
              {missionsMinistry.closing}
            </p>
          </Rise>
          <Rise>
            <GlowButton href={missionsMinistry.cta.href} variant="blue" testId="missions-ministry-cta">
              {missionsMinistry.cta.label}
            </GlowButton>
          </Rise>
        </Reveal>
      </div>
    </section>
  );
}
